import { ClassroomBookingValidationErrorUnion, ValidationErrorReason } from "@models/ISchema";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

const getValidationErrors = (
  validationErrors?: Array<ClassroomBookingValidationErrorUnion | null> | null,
) => (validationErrors ?? []).filter(Boolean) as ClassroomBookingValidationErrorUnion[];

export const getClassroomBookingValidationMessage = (
  t: TranslateFn,
  validationErrors?: Array<ClassroomBookingValidationErrorUnion | null> | null,
  fallbackKey = "booking.booking-list.notifications.status-change-error",
) => {
  const errors = getValidationErrors(validationErrors);

  const clashErrors = errors.filter(error => error.__typename === "ClassroomClash") as Extract<
    ClassroomBookingValidationErrorUnion,
    { __typename?: "ClassroomClash" }
  >[];
  if (clashErrors.length) {
    const sessionIds = Array.from(
      new Set(
        clashErrors.flatMap(
          error => (error.sessions ?? []).map(session => session?.id).filter(Boolean) as string[],
        ),
      ),
    );

    if (sessionIds.length) {
      return `${t("booking.booking-request.notifications.clash-error.description")} ${t(
        "booking.notifications.conflicting-sessions",
        {
          sessionIds: sessionIds.join(", "),
        },
      )}`;
    }

    return t("booking.booking-request.notifications.clash-error.description");
  }

  const holidayError = errors.find(error => error.__typename === "InvalidSessionInHoliday");
  if (holidayError) {
    return t("booking.booking-request.notifications.invalid-session-in-holiday.description");
  }

  const invalidInput = errors.find(error => error.__typename === "InvalidInput") as Extract<
    ClassroomBookingValidationErrorUnion,
    { __typename?: "InvalidInput" }
  >;
  if (invalidInput?.code === ValidationErrorReason.IntervalNotFound) {
    return t("booking.booking-request.notifications.interval-not-found.description");
  }

  if (invalidInput?.code === ValidationErrorReason.InvalidClassroom) {
    return t("booking.booking-request.notifications.invalid-classroom.description");
  }

  const invalidDate = errors.find(error => error.__typename === "InvalidDate");
  if (invalidDate) {
    return t("booking.booking-request.notifications.invalid-date.description");
  }

  return t(fallbackKey);
};
